import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import {
    FaBars,
    FaTimes,
    FaSignInAlt,
    FaMoon,
    FaSun,
    FaChevronDown,
    FaTachometerAlt,
} from "react-icons/fa";
import { LiaSignInAltSolid } from "react-icons/lia";
import { Popover, ConfigProvider } from "antd";
import "antd/dist/reset.css";
import Navstyles from "../Comman.module.css";
import NavModuleStyles from "./Nav.module.css";
import Logo from "../../../Assets/KohereHedaer.png";
import Logoblue from "../../../Assets/login/blue-logo.svg";
import { getAllCategoryWithServices } from "../../../Services/APIrequests";
import useStore from "../../../Store";
import { FaCircle } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import { Tooltip } from "react-tooltip";

// import { useLocation } from "react-router-dom";
const Nav = () => {
    const { name } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [themeDropdownOpen, setThemeDropdownOpen] = useState(false);
    const [selectedTheme, setSelectedTheme] = useState("");
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1440);
    const [isOpen, setIsOpen] = useState(true);
    const [subCategories, setSubCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { Theme, setTheme } = useStore();
    const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
    const [categoriesWithServices, setCategoriesWithServices] = useState([]);
    const [openCategory, setOpenCategory] = useState(null); // to track which category is open

    const dropdownRef = useRef(null);

    const isServiceActive = location.pathname.startsWith("/services");
    console.log(location.pathname);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setThemeDropdownOpen(false);
            }
        };

        // Add the event listener to detect clicks outside
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Toggle Theme
    const toggleTheme = (theme) => {
        const newTheme = theme != "blue" ? "dark" : "default";
        setTheme(newTheme);
        setSelectedTheme(theme);
        document.documentElement.setAttribute("data-theme", newTheme);
    };

    const handleNavigation = () => {
        navigate("/kohere/Dashboard");
    };

    // Fetch services and categories from API
    useEffect(() => {
        const fetchServicesData = async () => {
            setLoading(true);
            try {
                const response = await getAllCategoryWithServices();
                if (Array.isArray(response.data?.categoriesWithServices)) {
                    setCategoriesWithServices(
                        response.data?.categoriesWithServices
                    );
                } else {
                    console.error(
                        "API response is not an array:",
                        response.data?.categoriesWithServices
                    );
                }
            } catch (err) {
                console.error("Error fetching services:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchServicesData();
    }, []);

    useEffect(() => {
        let theme = sessionStorage.getItem("theme");
        if (theme) {
            setSelectedTheme(theme == "dark" ? "green" : "blue");
        }
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 1024);
            setIsOpen(window.innerWidth > 950);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const signup = () =>
        navigate("/signup", { state: { from: location.pathname } });
    const login = () => {
        console.log(location.pathname);
        sessionStorage.setItem("redirectUrl", location.pathname);
        navigate("/login", { state: { from: location.pathname } });
    };

    const logout = () => {
        sessionStorage.removeItem("token");
        navigate("/");
    };

    const isHomePage = location.pathname === "/";
    const isLoggedIn = Boolean(sessionStorage.getItem("token"));

    return (
        <nav>
            <div className={Navstyles["main_navcontainer"]}>
                {/* Logo */}
                <div className={Navstyles["image_container"]}>
                    <Link to="/">
                        <img
                            src={Theme === "dark" ? Logo : Logoblue}
                            alt="logo"
                            className={Navstyles.hedimage}
                        />
                    </Link>
                </div>

                {/* Navigation Links */}
                {!loading && (
                    <div className={Navstyles["navcontainer"]}>
                        <ul
                            className={`${Navstyles.navitems} ${menuOpen ? Navstyles.open : ""
                                }`}>
                            <li>
                                <NavLink
                                    exact="true"
                                    to="/BusinessesforSale"
                                    className={({ isActive }) =>
                                        isActive
                                            ? `${NavModuleStyles.linkText} ${NavModuleStyles.active}`
                                            : NavModuleStyles.linkText
                                    }>
                                    Businesses for Sale
                                </NavLink>
                            </li>

                            {categoriesWithServices.map((item) => (
                                <li
                                    className={Navstyles.navservicesitem}
                                    key={item.categoryName}>
                                    {item.services && item.services.length > 0 ? (
                                        <ConfigProvider
                                            theme={{
                                                token: {
                                                    colorBgElevated: '#ffffff',
                                                    borderRadiusLG: 8,
                                                },
                                            }}>
                                            <Popover
                                                content={
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: '0px',
                                                            minWidth: '250px',
                                                            maxHeight: '300px',
                                                            overflowY: 'auto',
                                                        }}>
                                                        {item.services.map(
                                                            (service, index) => (
                                                                <NavLink
                                                                    key={
                                                                        service.serviceId
                                                                    }
                                                                    to={`/services/${service.serviceId
                                                                        }/${encodeURIComponent(
                                                                            service.title.replace(
                                                                                /\s+/g,
                                                                                "-"
                                                                            )
                                                                        )}`}
                                                                    className={({ isActive }) =>
                                                                        isActive
                                                                            ? `${NavModuleStyles.linkText} ${NavModuleStyles.active}`
                                                                            : NavModuleStyles.linkText
                                                                    }
                                                                    style={{
                                                                        padding: '14px 16px',
                                                                        display: 'block',
                                                                        backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff',
                                                                        transition: 'all 0.2s ease',
                                                                        borderLeft: '3px solid transparent',
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.backgroundColor = '#e8f4ff';
                                                                        e.currentTarget.style.borderLeftColor = 'var(--PrimaryColor)';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#f8f9fa' : '#ffffff';
                                                                        e.currentTarget.style.borderLeftColor = 'transparent';
                                                                    }}>
                                                                    {service?.title}
                                                                </NavLink>
                                                            )
                                                        )}
                                                    </div>
                                                }
                                                trigger="hover"
                                                placement="bottomLeft"
                                                arrow={false}
                                                overlayStyle={{
                                                    paddingTop: '8px',
                                                }}>
                                                <NavLink
                                                    exact="true"
                                                    to={`/services/${item.categoryName.replace(
                                                        /\s+/g,
                                                        "_"
                                                    )}`}
                                                    className={({ isActive }) =>
                                                        isActive
                                                            ? `${NavModuleStyles.linkText} ${NavModuleStyles.active}`
                                                            : NavModuleStyles.linkText
                                                    }>
                                                    {item.categoryName}
                                                </NavLink>
                                            </Popover>
                                        </ConfigProvider>
                                    ) : (
                                        <NavLink
                                            exact="true"
                                            to={`/services/${item.categoryName.replace(
                                                /\s+/g,
                                                "_"
                                            )}`}
                                            className={({ isActive }) =>
                                                isActive
                                                    ? `${NavModuleStyles.linkText} ${NavModuleStyles.active}`
                                                    : NavModuleStyles.linkText
                                            }>
                                            {item.categoryName}
                                        </NavLink>
                                    )}
                                </li>
                            ))}

                            <li>
                                <NavLink
                                    exact="true"
                                    to="/resources"
                                    className={({ isActive }) =>
                                        isActive
                                            ? `${NavModuleStyles.linkText} ${NavModuleStyles.active}`
                                            : NavModuleStyles.linkText
                                    }>
                                    Resources
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    exact="true"
                                    to="/blog"
                                    className={({ isActive }) =>
                                        isActive
                                            ? `${NavModuleStyles.linkText} ${NavModuleStyles.active}`
                                            : NavModuleStyles.linkText
                                    }>
                                    Blog
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                )}

                {/* Buttons */}
                <div className={Navstyles["button-container"]}>
                    <div className={Navstyles["theme-dropdown-container"]}>
                        <button
                            className={Navstyles.nbtn}
                            // style={{ backgroundColor: '#2563eb' }}
                            onClick={() =>
                                setThemeDropdownOpen(!themeDropdownOpen)
                            }>
                            {isDesktop ? (
                                <>
                                    <FaSun
                                        className={Navstyles.nbtnicon}
                                        data-tooltip-id="theme-sun-tooltip"
                                        onClick={() =>
                                            setThemeDropdownOpen(
                                                !themeDropdownOpen
                                            )
                                        }
                                    />
                                    <Tooltip
                                        id="theme-sun-tooltip"
                                        content="Theme"
                                        place="left-start"
                                    />
                                </>
                            ) : (
                                <>
                                    <FaSun
                                        className={Navstyles.nbtnicon}
                                        data-tooltip-id="theme-sun-tooltip"
                                        onClick={() =>
                                            setThemeDropdownOpen(
                                                !themeDropdownOpen
                                            )
                                        }
                                    />
                                    <Tooltip
                                        id="theme-sun-tooltip"
                                        content="Theme"
                                        place="left-start"
                                    />
                                </>
                            )}
                        </button>

                        {themeDropdownOpen && (
                            <div
                                ref={dropdownRef}
                                className={Navstyles["theme-dropdown"]}>
                                <div
                                    onClick={() => toggleTheme("green")}
                                    className={Navstyles["theme-option"]}>
                                    <FaCircle
                                        checked={selectedTheme === "green"}
                                        readOnly
                                        className={Navstyles.themecircle1}
                                    />
                                </div>
                                <div
                                    onClick={() => toggleTheme("blue")}
                                    className={Navstyles["theme-option"]}>
                                    <FaCircle
                                        checked={selectedTheme === "blue"}
                                        readOnly
                                        className={Navstyles.themecircle2}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {isLoggedIn && (
                        <button
                            className={Navstyles.nbtn}
                            onClick={handleNavigation}>
                            <FaTachometerAlt className={Navstyles.nbtnicon} style={{ marginRight: isDesktop ? '8px' : '0' }} />
                            {isDesktop && "Dashboard"}
                        </button>
                    )}

                    <span className={Navstyles.nbtn_wrapper}>
                        {isLoggedIn ? (
                            <button
                                onClick={logout}
                                className={Navstyles.nbtn}
                                data-tooltip-id="logout-tooltip">
                                <FaSignInAlt className={Navstyles.nbtnicon} />
                                {isDesktop && <span style={{ marginLeft: '8px' }}>Logout</span>}
                            </button>
                        ) : (
                            <button
                                type="button"
                                className={NavModuleStyles.signInButton}
                                onClick={login}
                                style={{ padding: '14px 20px' }}
                            >
                                Login / Signup
                            </button>
                        )}
                    </span>

                    <button
                        className={Navstyles["menu"]}
                        type="button"
                        onClick={() => setMenuOpen(!menuOpen)}>
                        {menuOpen ? <FaTimes /> : <FaBars />}
                    </button>
                </div>

                {/* Mobile Menu Toggle */}
            </div>
        </nav>
    );
};

export default Nav;
